import { render, staticRenderFns } from "./percentage.vue?vue&type=template&id=573fcd5b&lang=pug&"
import script from "./percentage.vue?vue&type=script&lang=js&"
export * from "./percentage.vue?vue&type=script&lang=js&"
import style0 from "./percentage.vue?vue&type=style&index=0&id=573fcd5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports